import styled from 'styled-components';
import { Box, Link } from 'edenred-ui';

export const FileFormatButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  background: none;
  border: none;
  text-decoration: none;
  text-align: left;
  color: ${({ theme }) => theme.primaryFrontColor};
  font-size: ${({ theme }) => theme.sizeMedium};
  font-family: ${({ theme }) => theme.fontFamily};

  &:hover {
    background: ${({ theme }) => theme.primaryBackColorLight10};
    text-decoration: none;
  }

  &:focus,
  &:active {
    text-decoration: none;
  }
`;

export const SimpleLink = styled(Link)`
  color: ${({ theme }) => theme.primaryLinkColor};
`;

export const IngestroWrapper = styled(Box)`
  * {
    font-size: 16px !important;
    line-height: 20px !important;
  }

  h1 {
    font-size: 24px !important;
    line-height: 32px !important;
  }

  p {
    padding: 4px 8px !important;
  }

  button {
    padding: 8px 24px !important;
    height: unset !important;
    width: unset !important;

    &:disabled {
      background-color: #bdbdbd !important;
      color: #ffffff !important;
    }

    &.bg-white {
      color: #172057 !important;
      background-color: #ffffff !important;
      border-color: #172057 !important;
      border-radius: 24px !important;
    }
  }

  .w-full.p-3.will-change-transform.extra-scope-8qkufk {
    .mx-auto.mb-10 {
      margin-bottom: 35px !important;
    }
  }
  #nuvo-app-root-element [id^='nuvo-dev-banner-text-User'],
  .extra-scope-8qkufk,
  p[id^='nuvo-dev-banner-text-User'] {
    font-size: 16px !important;
  }

  .extra-scope-fzyit9 {
    display: none !important;
  }

  .extra-scope-1jj9i8 {
    align-items: baseline !important;
    margin-bottom: 16px !important;
  }

  div.simplebar-content > div,
  div.nuvo-dropdown-menu-pane > div {
    padding: 4px !important;
  }

  div#data-model-sheet-form div.relative div.extra-scope-wcvxuy {
    width: 250px !important;

    button {
      width: 100% !important;
    }
  }

  div.extra-scope-ix1izd,
  div.extra-scope-n5dya7,
  div.extra-scope-ebgumr {
    height: unset !important;

    button.absolute {
      top: 6px !important;
      right: 6px !important;
    }
  }

  button.extra-scope-clgfd9 {
    min-width: 140px !important;
  }

  #dropdown-scroll-element-id p.extra-scope-1686e33 {
    display: none !important;
  }
`;
